/* Pretty Panther quick view: the "+" on every product tile opens a pop-up with the product's photos,
   sizes, key facts and Add to bag. Content comes from sections/pp-quick-view.liquid. */
(() => {
  if (window.ppQuickView) return;
  window.ppQuickView = true;

  const cache = new Map();
  let dialog, body, opener;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // The pop-up's styles live in pp-quick-view.css next to this file (section styles only load where a section is on the page).
  const me = document.currentScript;
  if (me && me.src) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = me.src.replace('pp-quick-view.js', 'pp-quick-view.css');
    document.head.appendChild(link);
  }

  function build() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'pp-qv-dialog';
    dialog.setAttribute('aria-labelledby', 'pp-qv-title');
    dialog.innerHTML =
      '<button type="button" class="pp-qv-dialog__close" data-pp-qv-close aria-label="Close">' +
      '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 3l12 12M15 3 3 15"/></svg></button>' +
      '<div class="pp-qv-dialog__body" data-pp-qv-body></div>';
    document.body.appendChild(dialog);
    body = dialog.querySelector('[data-pp-qv-body]');
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-pp-qv-close]')) close();
    });
    dialog.addEventListener('close', () => {
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    });
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  async function load(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const url = `${root}products/${encodeURIComponent(handle)}?section_id=pp-quick-view`;
    const p = fetch(url, { credentials: 'same-origin' }).then((r) => {
      if (!r.ok) throw new Error('Could not load');
      return r.text();
    });
    cache.set(handle, p);
    p.catch(() => cache.delete(handle));
    return p;
  }

  async function open(handle, trigger) {
    build();
    opener = trigger;
    body.innerHTML = '<div class="pp-qv-dialog__loading" role="status">Loading…</div>';
    if (!dialog.open) dialog.showModal();
    try {
      const html = await load(handle);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-pp-qv-root]');
      body.innerHTML = '';
      if (!content) throw new Error('Empty');
      body.appendChild(document.importNode(content, true));
      syncWishlist();
      const first = body.querySelector('.pp-qv__title');
      if (first) { first.tabIndex = -1; first.focus({ preventScroll: true }); }
    } catch (err) {
      body.innerHTML = `<div class="pp-qv-dialog__loading">Sorry, this product couldn't be loaded. <a href="${root}products/${encodeURIComponent(handle)}">Open the product page</a></div>`;
    }
  }

  // Keep the heart in step with the tile's heart, which the theme's wishlist already manages.
  function syncWishlist() {
    const btn = body.querySelector('.pp-qv__wish');
    if (!btn) return;
    const tileHeart = document.querySelector(`.pp-tile__wish[data-pp-wishlist="${btn.dataset.ppWishlist}"]`);
    if (tileHeart) btn.setAttribute('aria-pressed', tileHeart.getAttribute('aria-pressed') || 'false');
  }

  function show(rootEl, index) {
    const slides = rootEl.querySelectorAll('[data-pp-qv-slide]');
    if (!slides.length) return;
    const n = slides.length;
    const i = ((index % n) + n) % n;
    slides.forEach((s, k) => { s.hidden = k !== i; s.classList.toggle('is-active', k === i); });
    rootEl.querySelectorAll('[data-pp-qv-thumb]').forEach((t, k) => {
      t.classList.toggle('is-active', k === i);
      if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    rootEl.dataset.index = i;
  }

  document.addEventListener('click', (e) => {
    const plus = e.target.closest('[data-pp-qv-open]');
    if (plus) {
      e.preventDefault();
      open(plus.dataset.ppQvOpen, plus);
      return;
    }
    if (!dialog || !dialog.contains(e.target)) return;
    const rootEl = e.target.closest('[data-pp-qv-root]');
    if (!rootEl) return;

    const go = e.target.closest('[data-pp-qv-go]');
    if (go) { show(rootEl, Number(rootEl.dataset.index || 0) + Number(go.dataset.ppQvGo)); return; }
    const thumb = e.target.closest('[data-pp-qv-thumb]');
    if (thumb) { show(rootEl, Number(thumb.dataset.ppQvThumb)); return; }

    const pill = e.target.closest('[data-pp-qv-variant]');
    if (pill) {
      const data = JSON.parse(rootEl.querySelector('[data-pp-qv-variants]')?.textContent || '[]');
      const v = data.find((x) => String(x.id) === pill.dataset.ppQvVariant);
      if (!v) return;
      rootEl.querySelectorAll('[data-pp-qv-variant]').forEach((b) => {
        const on = b === pill;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      rootEl.querySelector('[data-pp-qv-id]').value = v.id;
      const size = rootEl.querySelector('[data-pp-qv-size]');
      if (size) size.textContent = v.title;
      const price = rootEl.querySelector('[data-pp-qv-price]');
      if (price) price.innerHTML = v.price;
      const add = rootEl.querySelector('[data-pp-qv-add]');
      if (add) { add.disabled = !v.available; add.textContent = v.available ? (add.dataset.label || 'Add to bag') : 'Sold out'; }
      return;
    }

    if (e.target.closest('.pp-qv__wish')) setTimeout(() => {
      const btn = body.querySelector('.pp-qv__wish');
      const tileHeart = btn && document.querySelector(`.pp-tile__wish[data-pp-wishlist="${btn.dataset.ppWishlist}"]`);
      if (tileHeart) tileHeart.setAttribute('aria-pressed', btn.getAttribute('aria-pressed'));
    }, 50);
  });

  // After Add to bag, the theme opens the bag: close the pop-up so the bag is in front.
  document.addEventListener('submit', (e) => {
    if (!e.target.closest('[data-pp-qv-form]')) return;
    const started = Date.now();
    const wait = () => {
      const bag = document.getElementById('pp-cart-drawer');
      if (bag && bag.open) { close(); return; }
      if (Date.now() - started < 5000) setTimeout(wait, 100);
    };
    setTimeout(wait, 100);
  });

  // "Seller information" in the pop-up links to the product page: open that section there.
  const openSeller = () => {
    if (location.hash !== '#seller-information') return;
    const el = document.getElementById('seller-information');
    if (el && el.tagName === 'DETAILS') { el.open = true; el.scrollIntoView({ block: 'center' }); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openSeller); else openSeller();
  window.addEventListener('hashchange', openSeller);

  // Warm the cache when a shopper points at a "+".
  document.addEventListener('pointerover', (e) => {
    const plus = e.target.closest && e.target.closest('[data-pp-qv-open]');
    if (plus) load(plus.dataset.ppQvOpen).catch(() => {});
  }, { passive: true });
})();
